module.exports = __webpack_public_path__ + "static/media/Christopher A. OHerlihy@2x.6f102aa6.jpg";